import React from 'react'
import img from '../../assets/images/error.webp';
export default function Error() {
    return (
        <div className='d-flex flex-column justify-content-center align-items-center'>
            <img src={img} alt="Error" className='w-50' />
            <h3 className='fw-bolder'>Sorry, We missed up again .. Something went wrong </h3>
        </div>
    )
}
